import { roleConfig } from "../roleConfig"

const emailValidate = "^(([^<>()[\\]\\.,;:\\s@\"]+(\\.[^<>()[\\]\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$"

export const EditDeliverModalList = [
    {
        label: "姓名",
        name: "name",
        type: "text",
        placeholder: "請輸入姓名",
        required: true
    },
    {
        label: "公司",
        name: "company",
        type: "text",
        placeholder: "請輸入公司名稱",
        required: false
    },
    {
        label: "電話",
        name: "phone",
        type: "text",
        placeholder: "請輸入電話",
        required: true,
        pattern: "^09\\d{8}$",
        title: "未符合格式要求"
    },
    {
        label: "Email",
        name: "email",
        type: "email",
        placeholder: "請輸入 Email",
        required: true,
        pattern: emailValidate,
        title: "請確認email格式是否正確"
    },
    {
        label: "角色",
        name: "role",
        type: "select",
        placeholder: "請選擇角色",
        required: true,
        // 使用 roleConfig 來生成選項
        options: Object.entries(roleConfig).map(([label, value]) => ({ value, label }))
    },
    {
        label: "LINE ID",
        name: "lineId",
        type: "text",
        placeholder: "請輸入 LINE ID",
        required: true
    },
]

export const CreateDeliverModalList = [
    {
        label: "姓名",
        name: "name",
        type: "text",
        placeholder: "請輸入姓名",
        required: true
    },
    {
        label: "公司",
        name: "company",
        type: "text",
        placeholder: "請輸入公司名稱",
        required: false
    },
    {
        label: "電話",
        name: "phone",
        type: "text",
        placeholder: "請輸入電話",
        required: true,
        pattern: "^09\\d{8}$",
        title: "未符合格式要求"
    },
    {
        label: "Email",
        name: "email",
        type: "email",
        placeholder: "請輸入 Email",
        required: true,
        pattern: emailValidate,
        title: "請確認email格式是否正確"
    },
    {
        label: "角色",
        name: "role",
        type: "select",
        placeholder: "請選擇角色",
        required: true,
        // 使用 roleConfig 來生成選項
        options: Object.entries(roleConfig).map(([label, value]) => ({ value, label }))
    },
    {
        label: "密碼",
        name: "password",
        type: "password",
        placeholder: "請輸入密碼（至少 6 個字符）",
        required: true,
        minLength: 6,
        title: "密碼至少需要 6 個字符"
    },
    {
        label: "確認密碼",
        name: "confirmPassword",
        type: "password",
        placeholder: "請再次輸入密碼",
        required: true,
        minLength: 6,
        title: "密碼至少需要 6 個字符",
        matchField: "password"
    },
    {
        label: "LINE ID",
        name: "lineId",
        type: "text",
        placeholder: "請輸入 LINE ID",
        required: true
    },
]
